module.exports = __webpack_public_path__ + "img/google.d872a322.png";